const MiniCart = function () {
    const miniCartContainerClass = '.mini-cart-side-panel-container';
    const miniCartSidePanelSelector = miniCartContainerClass + ' .mini-cart-side-panel';
    const miniCartContentContainer = miniCartContainerClass + ' .mini-cart-content-container';
    const miniCartEmptySelector = miniCartContainerClass + ' .mini-cart-empty';
    const miniCartFullSelector = miniCartContainerClass + ' .mini-cart-full';
    const miniCartProductsListSelector = miniCartFullSelector + ' .mini-cart-side-panel--products-list';
    const miniCartHeaderSelector = miniCartContainerClass + ' .mini-cart-header';
    const miniCartFooterSelector = miniCartContainerClass + ' .mini-cart-side-panel--pricing';
    const miniCartSpontaneousPurchaseContainer = miniCartContainerClass + ' .mini-cart-spontaneous-purchase';
    const miniCartSpontaneousFooterSelector = miniCartContainerClass + ' .mini-cart-side-panel--spontaneous';
    const miniCartUPassContainer = miniCartContainerClass + ' .upass-advertising-container';
    const miniCartInterestingProducts = miniCartContainerClass + ' .mini-cart-interesting-products';
    const $body = $('body');

    let miniCartWithTaxes = false;
    let redirectingToCheckout = false;

    //****************************************************************
    // Ajax
    //****************************************************************

    const _getMiniCart = function () {
        TINK.inProgress($body);
        $.ajax({
            url: miniCartUrl + '/entries',
            type: 'GET',
            headers: {
                'Accept-Language': lang
            },
            dataType: 'json',
            cache: false,
            success: function (data) {
                _updateMiniCartHeader(data.cartNbItems);
                _updateMiniCartSpontaneousReadyCondition(data.cartTotalEntries, data.cartMaxItemNumber);
                _triggerModal();
                _toggleEmptyMiniCart(data.empty)
                _displayMiniCartProducts(data);
                updateQtyIncrementerButtonsState();
                _updateMiniCartFooter(data);
                _bindAnalytics();
                if (data.cartNbItems <= 1) {
                    _getInterestingProducts();
                }
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            },
            complete: function () {
                TINK.stopProgress($body);
            }
        });
    };

    const _refreshMiniCartSummary = function () {
        TINK.inProgress($(miniCartFooterSelector));

        let uPassAisleSubTotal;
        if (typeof uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            uPassAisleSubTotal = uPass.getCartUPassAisleSubTotal(uPassAisleId);
        }

        $.ajax({
            url: miniCartUrl + '/summary',
            data: {
                'forceUseLatestPrice': miniCartWithTaxes === true,
                'uPassAisleSubTotal': uPassAisleSubTotal
            },
            type: 'GET',
            headers: {
                'Accept-Language': lang
            },
            dataType: 'json',
            success: function (data) {
                _updateMiniCartFooter(data);
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            },
            complete: function () {
                TINK.stopProgress($(miniCartFooterSelector));
            }
        });
    };

    const _updateMiniCartProduct = function (event) {
        let $tile = $(this).closest('.item-addToCart'),
            $cutSelect = $tile.find('select[name="select_element"]'),
            optionCode = $cutSelect ? $cutSelect.attr('data-configuration-code') : null,
            optionId = $cutSelect ? $cutSelect.val() : null,
            entryNumber = +$tile.attr('data-cart-entry'),
            productCode = $tile.data('product-code'),
            itemData = {
                quantity: +$tile.find('.qty-addToCart').first().text(),
                productCode: productCode,
                optionCode: optionCode,
                optionId: optionId,
                substitutionPermission: $tile.find('.product--substitution input[type="checkbox"]').is(":checked") ? "YES" : "NO",
            };

        hideErrorMessages($tile);
        TINK.inProgress($tile);

        if (isNaN(entryNumber)) {
            _getMiniCart();
            return;
        }

        $.ajax({
            url: miniCartUrl + '/entries/' + entryNumber,
            type: "PATCH",
            headers: {
                "Accept-Language": lang
            },
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(itemData),
            dataType: 'json',
            success: function (data) {
                _updateHeaderCartItemNumber(data.cartNbItems);
                _updateProductTile($tile, data.entry);
                _updateMiniCartAislesCounts();
                _updateMiniCartHeader(data.cartNbItems);
                _refreshMiniCartSummary();
                updateProductTilesAfterUpdate(data.entry);
                var plusTriggered = $(event.target).hasClass('action__add-to-cart');
                if (plusTriggered) {
                    push_add_cart_info_metrics($tile, 1);
                } else if (!event.target.closest('.checkbox-basic-toggle')) {
                    // Make sure not to send metrics if the event comes from the substitution
                    push_remove_cart_info_metrics($tile, 1);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    reloadPage();
                }
            },
            complete: function () {
                TINK.stopProgress($tile);
            }
        });

        $(this).closest('.mc__qty--btn').find('.qtyProduct').focus();
    };

    const _deleteMiniCartItem = function () {
        let $tile = $(this).closest('.item-addToCart'),
            entryNumber = +$tile.attr('data-cart-entry'),
            productCode = $tile.data('product-code'),
            deleteDelayDuration = miniCartDeleteDelayEnabled && typeof miniCartDeleteDelayDuration !== 'undefined' ? miniCartDeleteDelayDuration : 0,
            itemData = {
                productCode: productCode
            };

        if (isNaN(entryNumber)) {
            TINK.inProgress($tile);
            _getMiniCart();
            return;
        }

        let refreshView = false
        if (uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            let $uPassAisle = $(miniCartProductsListSelector).find('[data-aisle="' + uPassAisleId + '"]');
            if ($uPassAisle.length) {
                let uPassProductCode = $uPassAisle.find('[data-product-code]').data('product-code');
                if (uPassProductCode === productCode) {
                    refreshView = true;
                }
            }
        }

        _disableCheckoutButton(true);
        _initDeleteTimer($tile, deleteDelayDuration);

        let timeoutID = setTimeout(function () {
            $.ajax({
                url: miniCartUrl + '/entries/' + entryNumber,
                type: "DELETE",
                headers: {
                    "Accept-Language": lang
                },
                data: JSON.stringify(itemData),
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (data) {
                    _updateHeaderCartItemNumber(data.cartNbItems);
                    _removeMiniCartProductLine($tile);
                    _toggleEmptyMiniCart(data.empty);
                    _updateMiniCartAislesCounts();
                    _updateMiniCartHeader(data.cartNbItems);
                    _refreshMiniCartSummary();
                    _resetProductTiles(productCode, data.existingProduct);
                    _disableCheckoutButton(false);
                    _updateExpressDelivery(data.cartTotalEntries);
                    push_remove_cart_info_metrics($tile);
                    if (refreshView) {
                        _getMiniCart();
                    }

                    if ($('#cartGeniusContent .cartGeniusContainer').length > 0) {
                        CartGeniusBanner.asyncLoadCartGeniusCallback();
                    }
                },
                error: function (jqXHR) {
                    if (!TINK.redirectIfConflict(jqXHR)) {
                        reloadPage();
                    }
                },
                complete: function () {
                    TINK.stopProgress($tile);
                }
            });
        }, deleteDelayDuration);

        $tile.attr('data-delete-timeout-id', timeoutID);
    };

    const _deleteAllMiniCartItems = function () {
        TINK.inProgress($(miniCartSidePanelSelector));
        let csrf =  $("meta[name='_csrf']").attr("content");
        push_remove_all_from_cart_info_metrics($('.mini--cart--product'));
        $.ajax({
            url: miniCartUrl + '/entries/all',
            type: "DELETE",
            headers: {
                "Accept-Language": lang, "X-CSRF-TOKEN": csrf
            },
            contentType: "application/json; charset=utf-8",
            success: function () {
                _updateMiniCartHeader(0);
                _updateExpressDelivery(0);
                _toggleEmptyMiniCart(true);
                _updateHeaderCartItemNumber(0);
                _emptyMiniCartProductsList();
                _resetProductTiles(null, false);
                _toggleHeaderVisibility(true);

                // Cart genius: load async the cart genius banner
                if($('#cartGeniusContent .cartGeniusContainer').length > 0) {
                    CartGeniusBanner.asyncLoadCartGeniusCallback();
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    reloadPage();
                }
            },
            complete: function () {
                TINK.stopProgress($(miniCartSidePanelSelector));
            }
        });
    };

    const _displayHaveYouForgotten = function (haveYouForgottenUrl) {
        let carouselClosed = sessionStorage.getItem('carouselClosed');
        if (carouselClosed || typeof haveYouForgottenUrl === "undefined") {
            return false;
        }

        $.ajax({
            url: haveYouForgottenUrl,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            success: function (data) {
                $('.haveYouForgottenContent').html(data);
            }
        });
    };

    const _getInterestingProducts = function () {
        if (typeof miniCartInterestingProductsEnabled == 'undefined' || !miniCartInterestingProductsEnabled) {
            return;
        }

        $.ajax({
            url: miniCartUrl + '/interesting-products',
            type: 'GET',
            headers: {
                'Accept-Language': lang
            },
            dataType: 'html',
            cache: false,
            success: function (data) {
                $(miniCartInterestingProducts).html(data);
                $(miniCartInterestingProducts).removeClass('hide');
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            },
            complete: function () {
                TINK.stopProgress($(miniCartSidePanelSelector));
            }
        });
    };

    //****************************************************************
    // Update dom
    //****************************************************************

    const _updateMiniCartHeader = function (cartNbItems) {
        let $miniCartHeader = $(miniCartHeaderSelector);
        $miniCartHeader.find('.miniCartNbItems').text(cartNbItems);
        cartNbItems > 1 ? $miniCartHeader.find('.miniCartNbItemsText').addClass('plural') : $miniCartHeader.find('.miniCartNbItemsText').removeClass('plural');

        if (!$('.mini-cart-sub-modal-container').length) {
            let miniCartSubModalClose = $('<button/>', {'class': 'close-sub'}).append($('<img/>', {'src': '/images/main/actions/close-x-white.svg', 'alt': ''}));
            let $miniCartSubModal = $('<div/>', {'class': 'mini-cart-sub-modal-container'}).append(miniCartSubModalClose).append($('<span/>', {'class': 'sub-desc-txt', 'tabindex' : '0'}));
            $(miniCartProductsListSelector).append($miniCartSubModal);
            $('.mini-cart-sub-modal-container .sub-desc-txt').text($('.mini-cart-full').data('sub-text'));
        }
    };

    const _updateMiniCartFooter = function (data) {
        let $miniCartFooter = $(miniCartFooterSelector);
        $miniCartFooter.find('.subtotal').text(data.subTotal);
        $miniCartFooter.find('.validDate').text(data.timeslotDateFormattedValue);

        if (data.minimumOrderAmountExceeded) {
            $miniCartFooter.find('button.checkout-button').removeClass('hide');
            $miniCartFooter.find('button.checkout-diff').addClass('hide');
            $miniCartFooter.find('.minimum-order-amount-warning-banner').addClass('hide');
        } else {
            $miniCartFooter.find('button.checkout-button').addClass('hide');
            $miniCartFooter.find('button.checkout-diff').removeClass('hide');
            if (typeof data.diffAmountForCheckout !== 'undefined') {
                $miniCartFooter.find('.diffAmountForCheckout_secondary').removeClass('hide');
                $miniCartFooter.find('.minimum-order-amount-warning-banner').removeClass('hide');
                $miniCartFooter.find('.amountLeftCheckout').text(data.diffAmountForCheckout);
                $miniCartFooter.find('.minimum-order-amount-text').text(data.minimumOrderAmount);
            } else {
                $miniCartFooter.find('button.checkout-diff').text($('#minicart-checkout-button').text());
                $miniCartFooter.find('.diffAmountForCheckout_secondary').addClass('hide');
            }
        }
        miniCartWithTaxes = data.withTaxes;

        // Show warning for minimum amount
        let $uPassWarningMessage = $(miniCartFooterSelector).find('.minimum-order-amount-warning');
        if ($uPassWarningMessage.length && uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            let $uPassAisle = $('[data-aisle="' + uPassAisleId + '"]');
            if ($uPassAisle.length) {
                if (typeof data.minimumOrderAmountText !== 'undefined') {
                    $uPassWarningMessage.text(data.minimumOrderAmountText);
                }
                if (data.minimumOrderAmountExceeded) {
                    $uPassWarningMessage.addClass('hide');
                }
            } else {
                $uPassWarningMessage.addClass('hide');
            }
        }

        _displayHaveYouForgotten(data.haveYouForgottenUrl);
    };

    const _setupUPassProducts = function (uPassProductsModel) {
        // Make sure container exists
        let $uPassContainer = $(miniCartUPassContainer);
        if (!$uPassContainer.length) {
            return false;
        }
        // Make sure upass products model is valid
        if (typeof uPassProductsModel === 'undefined' || uPassProductsModel === null || uPassProductsModel.length < 1) {
            $uPassContainer.addClass('hide');
            return false;
        }

        // Render UPass product list
        let $uPassProductList = $uPassContainer.find('.select-upass-product');
        $uPassProductList.empty();
        uPassProductsModel.forEach(function (uPassProductModel) {

            let uPassProductLabel = $('<label>', {
                for: uPassProductModel.code,
                text: uPassProductModel.name
            });
            uPassProductLabel.append($('<span>', {
                text: uPassProductModel.price
            }));
            $uPassProductList.append(uPassProductLabel);
            $uPassProductList.append($('<input>', {
                type: 'radio',
                id: uPassProductModel.code,
                value: uPassProductModel.code,
                name: 'upassProduct'
            }).attr('data-product-name', uPassProductModel.name));
        });

        _upassSelectControl($uPassContainer);
        _bindAddUPassProductEventListener($uPassContainer, $uPassProductList);
        $uPassContainer.removeClass('hide');
    };

    const _upassSelectControl = function ($uPassContainer) {
        let $firstUpassText = $uPassContainer.find('.select-upass-product label:first');
        let firstUpassValue = $firstUpassText.attr('for');
        let $uPassSelectBtn = $('#uPassSelectBtn', $uPassContainer);

        $uPassSelectBtn.html($firstUpassText.html());
        $('#' + firstUpassValue, $uPassContainer).prop('checked', true);

        $('.select-upass-product label', $uPassContainer).on('click', function () {
            let selectedUpassProductText = $(this).html();
            $uPassSelectBtn.empty().append(selectedUpassProductText);
            $uPassSelectBtn.click();
        });
    }

    const _bindAddUPassProductEventListener = function ($uPassContainer, $uPassProductList) {
        let $btnAddUPassProduct = $uPassContainer.find('.add-upass-product');
        $btnAddUPassProduct.off('click');
        $btnAddUPassProduct.prop('disabled', false);
        $btnAddUPassProduct.on('click', function () {
            $btnAddUPassProduct.prop('disabled', true);
            let $selectedProduct = $('input[name=upassProduct]:checked', $uPassProductList);
            let sku = $selectedProduct.val();
            let productName = $selectedProduct.attr('data-product-name');

            window['cartItem'] = new Product(sku, 1, undefined, undefined, productName, undefined, undefined, false);

            $.ajax({
                url: shoppingCartUrl + '/entries',
                type: 'POST',
                async: true,
                headers: {
                    'Accept-Language': window['acceptLanguage']
                },
                data: stringifyProduct(window['cartItem']),
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    _getMiniCart();
                },
                error: function (jqXHR) {
                    if (!TINK.redirectIfConflict(jqXHR)) {
                        reloadPage();
                    }
                }
            });
        });
    };

    const _displayMiniCartProducts = function (data) {

        _emptyMiniCartProductsList();

        if (!data.empty) {
            _setupUPassProducts(data.uPassProducts);
            data.aisles.forEach(function (aisle) {
                let $aisleDiv = $('<div/>', {
                    'class': 'mini--cart--aisle',
                    'data-aisle': aisle.aisleId
                });

                let $aisleQtySpan = $('<span/>', {'class': 'aisle-addToCart'}).append(' (' + aisle.count + ')');
                let $aisleName = $('<h4/>', {'class': 'subtitle-1'}).append(aisle.name, $aisleQtySpan);
                $aisleDiv.append($aisleName);

                aisle.entries.forEach(function (product) {
                    let $productTile = $('<div/>', {
                        'class': 'mini--cart--product item-addToCart' + (isNotEligible(product) ? ' item-not-qualify' : ''),
                        'data-product-code': product.sku,
                        'data-product-name': product.name,
                        'data-product-name-en': product.nameEn,
                        'data-product-brand': product.brand,
                        'data-product-subBrand': product.subBrand,
                        'data-product-category': product.mainCategory,
                        'data-product-category-en': product.mainCategoryEn,
                        'data-tile-type': 'mini-cart',
                        'data-unit-increment': product.unitIncrement,
                        'data-min-qty': product.minOrderQuantity,
                        'data-max-qty': product.maxOrderQuantity,
                        'data-qty': product.quantity,
                        'data-cart-entry': product.entryNumber,
                        'data-is-inactive': product.inactive,
                        'data-unit-name': product.unitName,
                        'data-main-price': product.unitPrice,
                        'data-substitution-permission': product.substitutionPermission,
                        'data-is-weighted': product.weightedProduct,
                        'data-subtotal-price': product.subTotalPrice,
                        'data-product-list-name': product.listName,
                        'data-product-alcohol': product.alcohol,
                        'data-selected-configuration-id': product.selectedConfigurationId
                    });

                    // --- left col
                    let $productLeftCol = $('<div/>', {'class': 'mc--product__left--col'});
                    let productName = product.subBrand ? product.name + ", " + product.subBrand : product.name;

                    let format = product.format ? product.format : null;
                    let deposit = product.deposit ? product.deposit : null;
                    let formatContent = [format, deposit].filter(item => item !== null).join(', ');
                    let $formatWrapper = $('<div/>', {'class': 'product--format'}).append($('<span/>').text(formatContent));

                    let $productImg = $('<a/>', {'href': product.url, 'class': 'product-details-link'}).append(
                        $('<img/>').attr('alt', productName)
                            .attr('src', product.imageUrl || '/images/main/icons/' + bannerCode + '/icon-no-picture.svg')
                            .attr('data-default', '/images/main/icons/' + bannerCode + '/icon-no-picture.svg')
                            .attr('onerror', 'replaceErrorImageByDefaultImage(this)'));

                    let $substitutionWrapper = $('<div/>', {'class': 'product--substitution'}).append($('<span/>').append('Substitution'));
                    let $substitutionCheckboxWrapper = $('<div/>', {'class': 'checkbox-basic-toggle'});
                    let substitutionText;
                    const hasSubstitutionAllowed = product.substitutionPermission === 'YES';
                    const displaySubstitution = product.displaySubstitution;
                    const disabled = !displaySubstitution;
                    const checked  = displaySubstitution && hasSubstitutionAllowed;
                    let substitutionIdentifier = product.entryNumber + '-toggle-switch-' + product.sku;

                    if (!displaySubstitution) {
                        substitutionText = (lang === 'fr') ? 'Non' : 'No';
                    } else {
                        substitutionText = product.substitutionPermissionText;
                    }
                    let $substitutionText = $('<span/>', {'class': 'checkbox-basic-toggle-text'}).append(substitutionText);

                    let $SubBtnmodal = $('<button/>', {'class': 'btn-show-substitution'}).append($('<img/>', {'src': '/images/shared/small/icons/questionmark.svg', 'alt': '', 'class': 'checkmark-img'}));

                    let $substitutionLabel = $('<label/>', {'for': substitutionIdentifier});
                    let $substitutionCheckbox = $('<input/>', {
                        'type': 'checkbox',
                        'name': substitutionIdentifier,
                        'id': substitutionIdentifier,
                        'disabled': disabled,
                        'checked': checked
                    });
                    let $substitutionSlider = $('<span/>', {'class': 'toggle--slider'});

                    $substitutionWrapper.append($substitutionCheckboxWrapper.append($substitutionLabel.append($substitutionCheckbox, $substitutionSlider)), $substitutionText, $SubBtnmodal);

                    let $productInfo = $('<div/>')
                        .append($('<div/>', {'class': 'pc--brand'}).append(product.brand))
                        .append($('<a/>', {'href': product.url, 'id': 'itemTitle-' + product.sku, 'class': 'product-details-link'}).append(productName))
                        .append($formatWrapper)
                        .append($substitutionWrapper).appendTo($productTile);

                    $productLeftCol.append($productImg, $productInfo);

                    // --- right col
                    let $minusSvg = $('<img class="cart-delete" src="/images/main/actions/' + bannerCode + '/remove-from-cart.svg" alt=""/><img class="cart-minus" src="/images/main/actions/' + bannerCode + '/minus-from-cart.svg" alt=""/>');
                    let $plusSvg = $('<img class="cart-plus" src="/images/main/actions/' + bannerCode + '/plus-to-cart.svg" alt=""/>');
                    let $productRightCol = $('<div/>', {'class': 'mc--product__right--col'});
                    let $productBtnMinus = $('<button/>', {'class': 'btn--minus minus-addToCart minus-updateMiniCart action__remove-from-cart'}).append($('<span/>', {'class': 'invisible-text'}));
                    $productBtnMinus.append($minusSvg);
                    let $productQtyText = $('<span/>', {'class': 'invisible-text'}).append(lang === 'fr' ? 'Quantité du produit dans le panier : ' : 'Quantity in cart: ');
                    let $productQty = $('<span/>', {'class': 'qty-addToCart' + (product.displayOrderUnitIncrement ? ' qty-long-txt' : '')}).append(product.quantity);
                    let $productUnit = product.displayOrderUnitIncrement ? ($('<span/>', {'class': 'qty-long-txt'}).append(' ' + product.unitName)) : '';
                    let $productBtnPlus = $('<button/>', {'class': 'btn--plus plus-addToCart plus-updateMiniCart action__add-to-cart'}).append($('<span/>', {'class': 'invisible-text'}));
                    $productBtnPlus.append($plusSvg);

                    let $productQtySelect = $('<div/>', {'tabindex': '0', 'class': 'pt__cart-amount'}).append($productQtyText, $productQty, $productUnit);
                    let $productActionWrapper = $('<div/>', {'class': 'actions__cart pt--actions'}).append($productBtnMinus, $productQtySelect, $productBtnPlus);
                    let $productQtyBtns = $('<div/>', {'class': 'pt__content--actions in-cart'}).append($productActionWrapper);

                    // hide cutting option if Express Delivery
                    let selectedConfiguration = '';
                    if (!($(miniCartSpontaneousFooterSelector).attr('data-express-service') === 'true')) {
                        selectedConfiguration = product.selectedConfiguration;
                    }
                    let $productSelectConfiguration = $('<span/>', {'class': 'mc--product__configuration'}).append(selectedConfiguration);
                    let formattedPrice = product.taxable ? product.formattedPrice + '<span class="roboto-regular"> +tx</span>' : product.formattedPrice;
                    let $productPrice = $('<span/>', {'class': 'body-medium-bold primary-bold ml-2 price-updateMiniCart', 'tabindex': '0'}).append(formattedPrice);

                    let $notEligibleMessage = getNotEligibleMessageBlockByService(product);

                    $productRightCol.append($productQtyBtns, $productPrice, $productSelectConfiguration, $notEligibleMessage);

                    let $deleteInProgressDiv = $('<div/>', {'class': 'cancel-delete'}).append('<span>' + (lang === 'fr' ? 'Produit supprimé' : 'Product removed') + '</span>');
                    let deleteCancelBtn = '<button type="button">' + (lang === 'fr' ? 'Annuler' : 'Undo') + ' (<span class="cancelDeleteTimer">3</span> sec)</button>';
                    $deleteInProgressDiv.append(deleteCancelBtn);

                    $productTile.append($productLeftCol, $productRightCol, $deleteInProgressDiv);
                    $aisleDiv.append($productTile);
                });
                $aisleDiv.append('<hr class="separator-small mb-20">');
                $(miniCartProductsListSelector).append($aisleDiv);
            });

            let miniCartSubModalClose = $('<button/>', {'class': 'close-sub'}).append($('<img/>', {'src': '/images/main/actions/close-x-white.svg', 'alt': ''}));
            let $miniCartSubModal = $('<div/>', {'class': 'mini-cart-sub-modal-container'}).append(miniCartSubModalClose).append($('<span/>', {'class': 'sub-desc-txt', 'tabindex' : '0'}));
            $(miniCartProductsListSelector).append($miniCartSubModal);
            $('.mini-cart-sub-modal-container .sub-desc-txt').text($('.mini-cart-full').data('sub-text'));
        }
    };

    const getNotEligibleMessageBlockByService = function (product) {
        let $notEligibleMessage;
        if (isNotEligible(product)) {
            $notEligibleMessage = "<div class='mc--item-not-qualify express-delivery'><div class='not-eligible__message'><span>" + getNotEligibleMessageByService() + "</span></div></div>";
        }
        return $notEligibleMessage;
    };

    const isNotEligible = function (product) {
        let hasAgeRestriction = product.ageRestriction && (isExpressService() || isInstacartService());
        let hasAlcoholRestriction = product.alcohol && (isFsaAlcoholRestricted() || isAlcoholDeliveryDisallowedByStore() || isAlcoholDeliveryDisallowedByTimeslot());
        return hasAgeRestriction || hasAlcoholRestriction;
    };

    const getNotEligibleMessageByService = function () {
        if (isExpressService()) {
            return expressNotEligibleMessage();
        } else if (isInstacartService()) {
            return instacartNotEligibleMessage();
        } else if (isFsaAlcoholRestricted()) {
            return fsaAlcoholRestrictedNotEligibleMessage();
        } else if (isAlcoholDeliveryDisallowedByStore()) {
            return alcoholDeliveryDisallowedByStoreMessage();
        } else if (isAlcoholDeliveryDisallowedByTimeslot()) {
            return alcoholDeliveryDisallowedByTimeslotMessage();
        }
    };

    const isExpressService = function () {
        return $(miniCartSpontaneousFooterSelector).attr('data-express-service') === 'true';
    };

    const isInstacartService = function () {
        return $(miniCartSpontaneousFooterSelector).attr('data-instacart') === 'true';
    };

    const isFsaAlcoholRestricted = function () {
        return $(miniCartSpontaneousFooterSelector).attr('data-cart-fsa-alcohol-restricted') === 'true';
    };

    const isAlcoholDeliveryDisallowedByStore = function () {
        return $(miniCartSpontaneousFooterSelector).attr('data-alcohol-delivery-disallowed-by-store') === 'true';
    };

    const isAlcoholDeliveryDisallowedByTimeslot = function () {
        return $(miniCartSpontaneousFooterSelector).attr('data-alcohol-delivery-disallowed-by-timeslot') === 'true';
    };

    const instacartNotEligibleMessage = function () {
        return (lang === 'fr' ? 'Non disponible pour la livraison Instacart' : 'Not eligible for Instacart Delivery');
    };

    const expressNotEligibleMessage = function () {
        return (lang === 'fr' ? 'Non disponible pour la Livraison Express' : 'Not eligible for Express Delivery');
    };

    const fsaAlcoholRestrictedNotEligibleMessage = function () {
        return (lang === 'fr' ? 'Ce produit n\'est pas disponible' : 'This item is not eligible for delivery');
    };

    const alcoholDeliveryDisallowedByStoreMessage = function () {
        return (lang === 'fr' ? 'Disponible en cueillette seulement' : 'Available for pickup orders only');
    };

    const alcoholDeliveryDisallowedByTimeslotMessage = function () {
        return (lang === 'fr' ? 'Notez que le produit n\'est pas disponible en livraison pour votre plage horaire.' : 'Please note that the product is not available for delivery for your time slot.');
    };

    const _updateProductTile = function ($tile, product) {
        let taxable = product.taxable ? '<span class="roboto-regular"> +tx</span>' : '';
        $tile.attr('data-cart-entry', product.entryNumber);
        $tile.attr('data-qty', product.quantity);
        $tile.attr('data-is-inactive', product.inactive);
        $tile.attr('data-subtotal-price', product.subTotalPrice);
        $tile.attr('data-substitution-permission', product.substitutionPermission);
        $tile.find('.qty-addToCart').text(product.quantity);
        $tile.find('.price-updateMiniCart').html(product.formattedPrice + taxable);
        $tile.find('.product--substitution .checkbox-basic-toggle-text').text(product.substitutionPermissionText);
    };

    const _updateMiniCartAislesCounts = function () {
        $(miniCartFullSelector + ' [data-aisle]').each(function () {
            let nbProductsInAisle = $(this).find('.mini--cart--product.item-addToCart').length;
            // If no product under an aisle delete the aisle bloc
            if (nbProductsInAisle < 1) {
                $(this).remove();
            } else {
                $(this).find('.aisle-addToCart').html(' (' + nbProductsInAisle + ')');
            }
        });
    };

    const _removeMiniCartProductLine = function ($tile) {
        TINK.stopProgress($tile);
        $tile.remove();
    };

    const _emptyMiniCartProductsList = function () {
        $(miniCartProductsListSelector).empty();
    };

    const _toggleEmptyMiniCart = function (empty) {
        let $miniCartFooter = $(miniCartFooterSelector);
        if (empty) {
            $(miniCartEmptySelector).removeClass('hide');
            $(miniCartFullSelector).addClass('hide');
            $miniCartFooter.addClass('hide');
        } else {
            $(miniCartEmptySelector).addClass('hide');
            $(miniCartFullSelector).removeClass('hide');
            $miniCartFooter.removeClass('hide');
        }
    };

    const _resetProductTiles = function (productCode, existingProduct) {
        let $productTiles = productCode != null ? $('[data-product-code="' + productCode + '"]') : $('[data-product-code]');
        if ($productTiles.length) {
            if (!existingProduct) {
                $productTiles.removeClass('item-in-cart');

                if ($productTiles.hasClass('productPDP')) {
                    $('.product-info').removeClass('item-in-cart');
                }
            }
        }

        // Reset product tiles except for cart starter tiles (since mini-cart deletions do not affect the cart starter products)
        let $productTilesToReset = productCode != null ? $('[data-product-code="' + productCode + '"]').not('.product-tile-cart-starter').not('.mini--cart--product') : $('[data-product-code]').not('.product-tile-cart-starter').not('.mini--cart--product');
        if ($productTilesToReset.length) {
            _resetDefaultTileState($productTilesToReset);
        }
    };

    const _getImpulsiveEntries = function (isMiniCart, targetContainer, targetFooter) {
        TINK.inProgress($(miniCartSidePanelSelector));

        let cartProductSkus = [];
        let $products = isMiniCart ? $(miniCartProductsListSelector + ' .mini--cart--product') : $('.basket-product-tiles .product-card');
        $products.each(function () {
            cartProductSkus.push($(this).data('product-code'));
        });
        let expressService = $(miniCartSpontaneousFooterSelector).attr('data-express-service');
        let instacartService = $(miniCartSpontaneousFooterSelector).attr('data-instacart');
        let alcoholRestricted = $(miniCartSpontaneousFooterSelector).attr('data-alcohol-delivery-disallowed-by-store')
            || $(miniCartSpontaneousFooterSelector).attr('data-alcohol-delivery-disallowed-by-timeslot')
            || $(miniCartSpontaneousFooterSelector).attr('data-cart-fsa-alcohol-restricted');

        $.ajax({
            url: impulsivePurchaseUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            headers: {
                'Accept-Language': lang
            },
            data: JSON.stringify({
                'cartProductSkus': cartProductSkus,
                'expressService': expressService,
                'instacartService': instacartService,
                'alcoholRestricted': alcoholRestricted,
            }),
            cache: false,
            success: function (data) {
                if (data === undefined) {
                    //Jump to checkout
                    _closeModal();
                    CartUtil.checkLoginAndGoToCheckout(isMiniCart);
                    return false;
                }

                //If we come from the full-cart, display the mini-cart panel
                if (!isMiniCart) {
                    if (!$(miniCartSidePanelSelector).hasClass('remodal-is-opened')) {
                        $('#miniCartModal').remodal().open();
                    }
                }

                //Hide mini cart content panel
                $(miniCartContentContainer).addClass('hide');
                $(miniCartFooterSelector).addClass('hide');

                //Show spontaneous purchase panel
                $(targetContainer).html(data);
                $(targetContainer).removeClass('hide');
                $(targetFooter).removeClass('hide');

                //Initialize NO THANKS button
                let $noThanksBtn = $('.checkout-button--spontaneous');
                $noThanksBtn.text(impulsivePurchaseNoThankYouMessage);
                $noThanksBtn.removeClass('cta-primary').addClass('cta-secondary').addClass('no-thank-you');
                $('.product-tile-spontaneous .pt__content--actions .plus-updateCart').on('click', function () {
                    UAEvents.click(this, 'product', 'documentOpen', '', '.product-tile-spontaneous', false);
                });
                $('.product-tile-spontaneous .pt__content--actions .minus-updateCart').on('click', function () {
                    UAEvents.click(this, 'product', 'documentOpen', '', '.product-tile-spontaneous', false);
                });
                $('.product-tile-spontaneous .product-details-link, .product-tile-spontaneous .pt__visual a').on('click',function () {
                    UAEvents.click(this, 'product', 'documentOpen', '',  '.product-tile-spontaneous', false);
                });

                focusOnMySelect();

                //Define listener when called from mini-cart
                $('.mini-cart-side-panel-container .mini-cart-side-panel--spontaneous .checkout-button').on('click', function () {
                    if (isCurrentPageCartPage && !isAuthenticated && _hasSpontaneousProductInCart()) {
                        //Define listener for the signin modal closing event
                        $('#popover-sign-in-box-container .p__close').click(function () {
                            if (!$('#sign-in-box').hasClass('in-progress')) {
                                document.location.reload(true);
                            }
                        });
                    }
                    CartUtil.checkTimeslotAndGoToCheckout(this, isMiniCart);
                });
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            },
            complete: function () {
                TINK.stopProgress($(miniCartSidePanelSelector));
                TINK.trapFocus($('#miniCartModal.remodal.mini-cart-side-panel'));
            }
        });
    };

    //****************************************************************
    // Misc
    //****************************************************************

    let lastScrollTop = 60;
    $(miniCartContentContainer).on('scroll', function () {
        const offset = this.pageYOffset || this.scrollTop;
        const hideHeader = offset > lastScrollTop;
        _toggleHeaderVisibility(!hideHeader);
    });

    const _triggerModal = function () {
        if (!$(miniCartSidePanelSelector).hasClass('remodal-is-opened')) {
            $('#miniCartModal').remodal().open();
            TINK.updateStatusNotification(window['miniCartOpenMessage']);
            TINK.trapFocus($('#miniCartModal.mini-cart-side-panel'), _closeModal());
        }

        //Make sure to hide spontaneous purchase panel
        $(miniCartSpontaneousPurchaseContainer).addClass('hide');
        $(miniCartSpontaneousFooterSelector).addClass('hide');
        $(miniCartSpontaneousPurchaseContainer).empty();

        //Make sure the mini cart is visible
        $(miniCartContentContainer).removeClass('hide');
        $(miniCartFooterSelector).removeClass('hide');
    };

    const _triggerSpontaneousPurchaseModal = function (isMiniCart) {
        //Hide mini cart content panel
        $(miniCartContentContainer).addClass('hide');
        $(miniCartFooterSelector).addClass('hide');
        _getImpulsiveEntries(isMiniCart, miniCartSpontaneousPurchaseContainer, miniCartSpontaneousFooterSelector);
    };

    const _closeModal = function () {
        if ($(miniCartSidePanelSelector).hasClass('remodal-is-opened')) {
            $('#miniCartModal').remodal().close();
            _cleanUpOnModalClose();
            TINK.updateStatusNotification(window['miniCartCloseMessage']);
            $('.cart--btn').focus();
        }
    }

    const _hasSpontaneousProductInCart = function () {
        let impulsiveProductCount = $('.mini-cart-spontaneous-purchase .product-tile-spontaneous-purchase');
        let addedImpulsiveProductCount = $('.mini-cart-spontaneous-purchase .actions--not-in-cart');

        return (impulsiveProductCount.length != addedImpulsiveProductCount.length);
    }

    const _updateFullCartSpontaneousReadyCondition = function () {
        let $maxItemSection = $(".express-delivery-max-item");
        if ($maxItemSection.length) {
            _updateMiniCartSpontaneousReadyCondition(parseInt($maxItemSection.attr('data-total-entries')), parseInt($maxItemSection.attr('data-max-item-number')));
        }
    }

    const _updateMiniCartSpontaneousReadyCondition = function (totalEntries, maxEntries) {
        //Make sure that the max entries criteria is defined
        let maxEntriesCriteria = $(miniCartSpontaneousFooterSelector).attr('data-max-entries-criteria');
        if (typeof maxEntriesCriteria !== 'undefined') {
            _updateSpontaneousMaxItemReached(totalEntries >= maxEntries);
            _updateMiniCartCheckoutReadyCondition(totalEntries, maxEntries);
        }
    }

    const _updateMiniCartCheckoutReadyCondition = function (totalEntries, maxEntries) {
        let $checkoutBtn = $(miniCartFooterSelector).find('button.checkout-button');
        if ($checkoutBtn.length) {
            let disable = false;
            if (totalEntries > maxEntries) {
                disable = true;
                $checkoutBtn.text(maxItemTotalExceededMessage.replace('{0}', totalEntries).replace('{1}', maxEntries));
            } else {
                $checkoutBtn.text(checkoutButtonMessage);
            }

            let deleteTimersCount = $(miniCartProductsListSelector + ' [data-delete-timeout-id]').length;
            $checkoutBtn.prop('disabled', disable || deleteTimersCount > 0);
        }
    }

    const _updateSpontaneousMaxItemReached = function (maxEntriesReached) {
        if (maxEntriesReached) {
            $(miniCartSpontaneousPurchaseContainer).addClass('max-item-reached');
        } else {
            $(miniCartSpontaneousPurchaseContainer).removeClass('max-item-reached');
        }
    }

    const _canShowImpulsivePanel = function () {
        let $maxItemReached = $(".mini-cart-spontaneous-purchase.max-item-reached");
        if ($maxItemReached.length) {
            return false;
        }

        let count = sessionStorage.getItem("impulsive-purchase-display-count");

        if (count === null) {
            count = 0;
        } else {
            count = parseInt(count);
        }

        if (count >= impulsivePurchaseMaxDisplay) {
            return false;
        } else {
            count = count + 1;
            sessionStorage.setItem("impulsive-purchase-display-count", count);
            return true;
        }
    };

    const _toggleHeaderVisibility = function (visible) {
        if (visible) {
            $(miniCartSidePanelSelector + ' .modal__close').removeClass('cart--btn--scrolled');
        } else {
            $(miniCartSidePanelSelector + ' .modal__close').addClass('cart--btn--scrolled');
        }
    };

    const _cleanUpOnModalClose = function () {
        $body.css('padding-right', '0'); // fix remodal
        _emptyMiniCartProductsList(); // make DOM smaller in hidden modal (since next modal opening will reconstruct html)

        //if the user has chosen an impulsive purchase, we reload the cart
        if (!redirectingToCheckout && isCurrentPageCartPage && _hasSpontaneousProductInCart()) {
            //make sure the login modal is not open
            if (!$('#popover-sign-in-box-button').hasClass('is_active')) {
                document.location.reload(true);
            }
        }

        redirectingToCheckout = false;
    };

    const _manageMiniCartFocus = function () {
        $(miniCartHeaderSelector + ' h2').focus();
    };

    const _initDeleteTimer = function ($tile, deleteDelayDuration) {
        if (miniCartDeleteDelayEnabled) {
            $tile.addClass('delete-in-progress');

            const $cancelDeleteBtn = $tile.find('.cancelDeleteTimer');
            let sec = deleteDelayDuration / 1000;
            $cancelDeleteBtn.text(sec);
            let countdownInterval = setInterval(function () {
                sec--;
                if (sec > 0) {
                    $cancelDeleteBtn.text(sec);
                } else {
                    clearInterval(countdownInterval);
                }
            }, 1000);

            $tile.attr('data-delete-countdown-interval-id', countdownInterval);
        } else {
            TINK.inProgress($tile);
        }
    };

    const _disableCheckoutButton = function (disable) {
        let $checkoutBtn = $(miniCartFooterSelector).find('button.checkout-button');
        let deleteTimersCount = $(miniCartProductsListSelector + ' [data-delete-timeout-id]').length;
        $checkoutBtn.prop('disabled', disable || deleteTimersCount > 0);
    };

    const _bindAnalytics = function () {
        ga4ViewCart();
    };

    //****************************************************************
    // Expose for binding
    //****************************************************************

    return {
        getMiniCart: _getMiniCart,
        updateMiniCartProduct: _updateMiniCartProduct,
        deleteMiniCartItem: _deleteMiniCartItem,
        deleteAllMiniCartItems: _deleteAllMiniCartItems,
        cleanUpOnModalClose: _cleanUpOnModalClose,
        manageMiniCartFocus: _manageMiniCartFocus,
        disableCheckoutButton: _disableCheckoutButton,
        getImpulsiveEntries: _getImpulsiveEntries,
        triggerSpontaneousPurchaseModal: _triggerSpontaneousPurchaseModal,
        canShowImpulsivePanel: _canShowImpulsivePanel,
        updateFullCartSpontaneousReadyCondition: _updateFullCartSpontaneousReadyCondition,
        updateMiniCartSpontaneousReadyCondition: _updateMiniCartSpontaneousReadyCondition,
        closeModal: _closeModal,
        setRedirectingToCheckout: function (value) {
            redirectingToCheckout = value;
        }
    };
}();


//****************************************************************
// Binding
//****************************************************************

$('.metro-menu #my-cart-link').on('click', function (e) {
    if (typeof miniCartUrl !== 'undefined') {
        if (TINK.matchMediaTabletDesktop(true) && !isCurrentPageCartPage) {
            e.preventDefault();
            MiniCart.getMiniCart();
            return false;
        }
    }
});

$(document).on('confirmation', '[data-remodal-id="delete-all-minicart-items"]', MiniCart.deleteAllMiniCartItems);
$(document).on('click', '.mini--cart--product button.plus-updateMiniCart, button:not(.lastInCart).minus-updateMiniCart', debounce(MiniCart.updateMiniCartProduct, 500));
$(document).on('click', '.mini--cart--product .checkbox-basic-toggle input[type=checkbox]', debounce(function (event) {
    MiniCart.updateMiniCartProduct.call(this, event);
    pushDataLayerSubstitutionChanged.call(this, event);
}, 500));
$(document).on('click', '.mini--cart--product button.lastInCart', debounce(MiniCart.deleteMiniCartItem, 250));

$(document).on('click', '.mini-cart-full button.btn-show-substitution', function() {
    const $row = $(this).closest('.product--substitution');
    const $modalSub = $('.mini-cart-sub-modal-container');
    $row.append($modalSub);

    if ($row.find('input[type=checkbox]:disabled').length > 0) {
        $('.mini-cart-sub-modal-container .sub-desc-txt').text($('.mini-cart-full').data('sub--restricted'));
    } else {
        $('.mini-cart-sub-modal-container .sub-desc-txt').text($('.mini-cart-full').data('sub-text'));
    }

    $('.mini-cart-full .mini-cart-sub-modal-container').css({"display": "flex"});
    TINK.trapFocus($modalSub);
});

$(document).on('click', '.mini-cart-full .mini-cart-sub-modal-container .close-sub', function() {
    $('.mini-cart-full .mini-cart-sub-modal-container').css({"display": "none"});
});

$(document).on('click', '.mini--cart--product .cancel-delete button', function () {
    const $tile = $(this).closest('.item-addToCart');
    clearTimeout($tile.attr('data-delete-timeout-id'));
    clearInterval($tile.attr('data-delete-countdown-interval-id'));
    $tile.removeAttr('data-delete-timeout-id');
    $tile.removeAttr('data-delete-countdown-interval-id');
    $tile.removeClass('delete-in-progress');
    MiniCart.disableCheckoutButton(false);
});

$(function () {
    let deleteAllMiniCartRemodal = $('[data-remodal-id="delete-all-minicart-items"]').remodal();
    $('button.deleteAllMiniCart').on('click', function () {
        deleteAllMiniCartRemodal.open();
    });

    $('.mini-cart-side-panel-container .mini-cart-side-panel--pricing .checkout-button').on('click', function () {
        if (MiniCart.canShowImpulsivePanel()) {
            MiniCart.getImpulsiveEntries(true, '.mini-cart-side-panel-container .mini-cart-spontaneous-purchase', '.mini-cart-side-panel-container .mini-cart-side-panel--spontaneous');
        } else {
            CartUtil.checkTimeslotAndGoToCheckout(this, true);
        }
    });

    uPass.setBanner();
});